var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products-availabilities-view"
  }, [(_vm.gridLoaded) ? _c('data-grid', {
    staticClass: "uk-margin-medium",
    attrs: {
      "columns": _vm.gridColumns,
      "is-loading": _vm.isLoading,
      "page-info": _vm.productAvailabilities.pagination,
      "rows": _vm.productAvailabilities.entries,
      "sort-info": _vm.productAvailabilities.sort,
      "sortable": ['provider', 'stock', 'deliveryLeadTime', 'updatedAt']
    },
    on: {
      "sort": _vm.sortBy
    },
    scopedSlots: _vm._u([{
      key: "provider",
      fn: function(props) {
        return [_c('provider-name', {
          attrs: {
            "name": props.row.provider
          }
        })]
      }
    }, {
      key: "deliveryLeadTime",
      fn: function(props) {
        return [(props.row.deliveryLeadTime) ? _c('delivery-lead-time', {
          attrs: {
            "value": props.row.deliveryLeadTime
          }
        }) : _c('text-placeholder')]
      }
    }, {
      key: "updatedAt",
      fn: function(props) {
        return [_c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": props.row.updatedAt
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(props) {
        return [_c('data-grid-actions', {
          staticClass: "data-grid__actions",
          attrs: {
            "editable": "",
            "removable": ""
          },
          on: {
            "edit": function($event) {
              _vm.editProductAvailability(props.row)
            },
            "remove": function($event) {
              _vm.deleteRecordWhenConfirmed(props.row)
            }
          }
        })]
      }
    }])
  }) : _c('div', {
    staticClass: "loader-container uk-container uk-margin-medium-top uk-text-center"
  }, [_c('loader')], 1), _vm._v(" "), _c('product-availability-editor', {
    ref: "productAvailabilityEditor",
    on: {
      "change": _vm.refetchList
    }
  }), _vm._v(" "), _c('common-button', {
    attrs: {
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": _vm.addProductAvailability
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.add')))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-153e502c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Products/AvailabilitiesView.vue
// module id = 1871
// module chunks = 0